export default __webpack_public_path__ + "static/media/hands.019770eb.png";